import React from 'react';
import { COLORS, RADIUS, SHADOW, BLUR } from '../../styles/tokens';

export interface GlassCardProps {
  children: React.ReactNode;
  /** Inner padding; defaults to a clamp() that matches section cards. */
  padding?: React.CSSProperties['padding'];
  /** When set, card lifts on hover and emits a soft glow in this colour. */
  hoverGlow?: string;
  /** Pass-through className (for extra layout/animation classes). */
  className?: string;
  /** Extra inline style overrides — last in cascade. */
  style?: React.CSSProperties;
}

// Reusable dark glass-morphism card matching ProblemSection / HowItWorks /
// WhyBetter / Trust / ReportPreview / PlanForm cards. One source of truth for
// the surface look; per-instance accents are passed as props.
export default function GlassCard({
  children,
  padding = 'clamp(20px, 2.5vw, 28px)',
  hoverGlow,
  className,
  style,
}: GlassCardProps) {
  return (
    <div
      className={className}
      style={{
        background: COLORS.glassBg,
        backdropFilter: BLUR.card,
        WebkitBackdropFilter: BLUR.card,
        border: `1px solid ${COLORS.glassBorder}`,
        borderRadius: RADIUS.card,
        padding,
        boxShadow: SHADOW.glass,
        transition: hoverGlow ? 'transform 0.24s ease, box-shadow 0.24s ease' : undefined,
        cursor: hoverGlow ? 'default' : undefined,
        ...style,
      }}
      onMouseEnter={hoverGlow
        ? (e) => {
            (e.currentTarget as HTMLElement).style.transform = 'translateY(-4px)';
            (e.currentTarget as HTMLElement).style.boxShadow = `0 16px 48px ${hoverGlow}`;
          }
        : undefined
      }
      onMouseLeave={hoverGlow
        ? (e) => {
            (e.currentTarget as HTMLElement).style.transform = 'translateY(0)';
            (e.currentTarget as HTMLElement).style.boxShadow = SHADOW.glass;
          }
        : undefined
      }
    >
      {children}
    </div>
  );
}
